import { lazy } from 'react'

export const TakeCallsVariant1 = lazy(() => import('./TakeCallsVariant1'))
